export const getDefaultSeriesData = () => {
  const res = {
    /**
     * 前轴电机端驱动力
     */
    UIRx_MotTq_FA: [],
    /**
     * 后轴电机端驱动力
     */
    UIRx_MotTq_RA: [],
    /**
     * FL制动力矩
     */
    UIRx_WhlBrkTqAct_FL_BCh1: [],
    /**
     * FR制动力矩
     */
    UIRx_WhlBrkTqAct_FR_BCh1: [],
    /**
     * RL制动力矩
     */
    UIRx_WhlBrkTqAct_RL_BCh1: [],
    /**
     * RR制动力矩
     */
    UIRx_WhlBrkTqAct_RR_BCh1: [],
  } as DomianControl.IFTFSeriesData;
  return res;
};
export type FunctionStatus = "制动正常" | "制动失效";

export function parseStatus(data: number): FunctionStatus {
  return data === 0 ? "制动正常" : "制动失效";
}

export function buildStatus(data: FunctionStatus) {
  return data === "制动失效" ? 1 : 0;
}
